var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.getSelectedDetails(_vm.plan).special_price)?_c('b',[_vm._v(_vm._s(_vm.getSelectedDetails(_vm.plan).special_price))]):_c('b',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }